import { Component, OnInit } from '@angular/core';

import { FormField } from '@models/forms/form-field.model';
import { FormGroupComponent } from '../form-group/form-group.component';
import { FormsDirective } from '../../../directives/forms.directive';
import { ToastrService } from 'ngx-toastr';
import { ViewChild } from '@angular/core';
import { ViewContainerRef } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import _ from 'lodash';
import { environment } from '@environments/environment';
import { forEach } from 'lodash';

@Component({
  selector: 'app-form-section',
  templateUrl: './form-section.component.html',
  styleUrls: ['./form-section.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FormSectionComponent implements OnInit {
  @ViewChild(FormsDirective, { static: true })
  private directive!: FormsDirective;
  private container!: ViewContainerRef;
  componentGroups: any[] = [];
  section!: FormField;
  familyComponent: any;
  PeopleImportantComponent: any;
  familyRelativesAddded: any[] = [];
  peopleImportantAdded: any[] = [];

  constructor(protected toastr: ToastrService) {}

  ngOnInit(): void {
    this.container = this.directive.viewContainerRef;
    this.container.clear();
    forEach(this.section.formFieldsetGroups, group => {
      const component =
        this.container.createComponent<FormGroupComponent>(FormGroupComponent);
      component.instance.group = group;
      component.instance.section = this.section;

      this.componentGroups.push(component);
    });

    this.familyComponent = this.componentGroups.find(
      element => element.instance.group.name === 'relative'
    );
    this.PeopleImportantComponent = this.componentGroups.find(
      element =>
        element.instance.group.name === 'people who are important to me'
    );
  }

  addFamilyRelative() {
    const fieldRes: {
      [key: string]: {
        value?: string | string[];
        status?: string;
        id?: string;
      };
    } = {};

    if (this.section.name === 'FAMILY_RESPONSIBLE_PARTY') {
      const groupToIterate =
        this.section.name === 'FAMILY_RESPONSIBLE_PARTY' &&
        this.section.formFieldsetGroups[0].name !==
          'people who are important to me'
          ? this.familyComponent
          : this.PeopleImportantComponent;
      for (const i in groupToIterate.instance.fields) {
        const key = groupToIterate.instance.fields[
          i
        ].instance.question.name.replace(' ', '_');

        //Validate the relative name and the relationship name
        if (
          (groupToIterate.instance.fields[i].instance.question.name.replace(
            ' ',
            '_'
          ) === 'relative_name' &&
            (groupToIterate.instance.fields[i].instance.form.field.value ===
              '' ||
              groupToIterate.instance.fields[i].instance.form.field.value ===
                undefined ||
              groupToIterate.instance.fields[i].instance.form.field.value ===
                null)) ||
          (groupToIterate.instance.fields[i].instance.question.name.replace(
            ' ',
            '_'
          ) === 'relative_relationship' &&
            (groupToIterate.instance.fields[i].instance.form.field.value ===
              '' ||
              groupToIterate.instance.fields[i].instance.form.field.value ===
                undefined ||
              groupToIterate.instance.fields[i].instance.form.field.value ===
                null))
        ) {
          this.toastr.error('Name and relationship fields are required');
          return;
        } else {
          //Start Getting data of the Tags field in family section , and delete checkboxes with false value
          if (
            groupToIterate.instance.fields[i].instance.question.id ===
            environment.relativeTagsFieldMigForm
          ) {
            _.keys(
              groupToIterate.instance.fields[i].instance.formData.value
            ).forEach(key => {
              if (
                groupToIterate.instance.fields[i].instance.formData.value[
                  key
                ] === null ||
                groupToIterate.instance.fields[i].instance.formData.value[
                  key
                ] === '' ||
                groupToIterate.instance.fields[i].instance.formData.value[
                  key
                ] === false
              ) {
                delete groupToIterate.instance.fields[i].instance.formData
                  .value[key];
              }
            });
          }
          //End deleting checkboxes with false values

          //Setting the value field
          if (fieldRes[key]) {
            fieldRes[key]['value'] =
              groupToIterate.instance.fields[i].instance.question.id ===
              environment.relativeTagsFieldMigForm
                ? _.keys(
                    groupToIterate.instance.fields[i].instance.formData.value
                  )
                : String(
                    groupToIterate.instance.fields[i].instance.formData.value
                      .field
                  );
          } else {
            fieldRes[key] = {
              value:
                groupToIterate.instance.fields[i].instance.question.id ===
                environment.relativeTagsFieldMigForm
                  ? _.keys(
                      groupToIterate.instance.fields[i].instance.formData.value
                    )
                  : String(
                      groupToIterate.instance.fields[i].instance.formData.value
                        .field
                    ),
            };
          }

          //Setting the status field
          if (fieldRes[key]) {
            fieldRes[key]['status'] =
              groupToIterate.instance.fields[i].instance.formData.status;
          } else {
            fieldRes[key] = {
              status:
                groupToIterate.instance.fields[i].instance.formData.status,
            };
          }

          //Setting the id field
          if (fieldRes[key]) {
            fieldRes[key]['id'] =
              groupToIterate.instance.fields[i].instance.question.id;
          } else {
            fieldRes[key] = {
              id: groupToIterate.instance.fields[i].instance.question.id,
            };
          }
        }
      }
      this.familyRelativesAddded.push(fieldRes);

      //Reset values
      for (const i in groupToIterate.instance.fields) {
        if (
          groupToIterate.instance.fields[i].instance.question.questionType ===
          'BOOLEAN'
        ) {
          groupToIterate.instance.fields[i].instance.formData.patchValue({
            field: false,
          });
        } else {
          groupToIterate.instance.fields[i].instance.formData.reset();
        }
      }
    }
  }

  deleteFamilyRelative(index: number) {
    this.familyRelativesAddded.splice(index, 1);
  }
}
